const mobileTransformTableClass = '.content-table_mobile-transform';

function addLoadingSpinner() {
    if (window.innerWidth <= 1079) {
        const tables = document.querySelectorAll(mobileTransformTableClass);

        tables.forEach((table) => {
            const loadingSpinner = document.createElement('div');

            loadingSpinner.classList.add('spinner');
            table.appendChild(loadingSpinner);
        });
    }
}

function resetTableItemHeight(tableItems) {
    tableItems.forEach((item) => {
        const itemElem = item.style;

        itemElem.height = '';
    });
}

function setTableItemHeights(mobileTransformTables: NodeListOf<Element>) {
    mobileTransformTables.forEach((table) => {
        const tableRows = table.querySelectorAll('tr');
        const maxHeights: number[] = [];

        if (window.innerWidth > 1079) {
            // Remove height from tableItem on desktop
            tableRows.forEach((row) => {
                const tableItems = row.querySelectorAll('td, th');

                resetTableItemHeight(tableItems);
            });
        } else {
            // Remove table item height on window resize for dynamic height adjustment
            tableRows.forEach((row) => {
                const tableItems = row.querySelectorAll('td, th');

                resetTableItemHeight(tableItems);
            });

            // Get the height for each column
            tableRows.forEach((row) => {
                const tableItems = row.querySelectorAll('td, th');

                tableItems.forEach((item, i) => {
                    const itemRect = item.getBoundingClientRect();

                    if (!maxHeights[i] || itemRect.height > maxHeights[i]) {
                        maxHeights[i] = itemRect.height;
                    }
                });
            });

            // Set the height of each cell in each column to the maximum height for that column
            tableRows.forEach((row) => {
                const tableItems = row.querySelectorAll('td, th');

                tableItems.forEach((item, i) => {
                    const itemElem = item as HTMLElement;

                    itemElem.style.height = `${maxHeights[i]}px`;
                });
            });
        }
    });
}

function setTableWidth(mobileTransformTables: NodeListOf<Element>) {
    mobileTransformTables.forEach((table) => {
        const bodyRows = table.querySelectorAll('tbody tr');
        const allRows = bodyRows.length;
        const allRowsMultiplied = allRows * 200;
        const contentTableHeader = '.content-table__header';
        const header = table.querySelector(contentTableHeader) as HTMLElement | null;
        const bodyRowsWidth = `${100 / allRows}%`;
        const headerWidth = header?.offsetWidth ?? 0;
        const tableElem = table as HTMLTableElement;
        const availableWidth = tableElem.offsetWidth - headerWidth;
        const contentTableFullWidth = 'content-table_text-heavy-type_full-width';

        if (allRowsMultiplied <= availableWidth) {
            table.classList.add(contentTableFullWidth);

            bodyRows.forEach((row) => {
                const rowCopy = row as HTMLElement;

                rowCopy.style.width = bodyRowsWidth;
            });
        } else {
            table.classList.remove(contentTableFullWidth);

            bodyRows.forEach((row) => {
                const rowCopy = row as HTMLElement;

                rowCopy.style.width = '';
            });
        }
    });
}

addLoadingSpinner();
let timeoutId;

window.addEventListener('load', () => {
    const mobileTransformTables = document.querySelectorAll(mobileTransformTableClass);
    const loadingSpinners = document.querySelectorAll('.spinner');

    mobileTransformTables.forEach((mobileTransformTable) => {
        mobileTransformTable.classList.remove('loading');

        setTableWidth(mobileTransformTables);
        setTableItemHeights(mobileTransformTables);

        window.addEventListener('resize', () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(() => {
                setTableWidth(mobileTransformTables);
                setTableItemHeights(mobileTransformTables);
                timeoutId = null;
            }, 250);
        });
    });

    loadingSpinners.forEach((loadingSpinner) => {
        loadingSpinner.remove();
    });
});

export {};
